import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import PageTop from "../../sections/PageTop";
import ContactForm from "./sections/ContactFormSect";
import MainReview from "../main/sections/MainReview";
import Location from "../../sections/Location";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "navContact",
  },
];

export default function Contact() {
  const { t } = useTranslation();

  return (
    <StyledContact>
      <PageTop title={t("contactPageTitle")} linkList={linkChain} />
      <ContactForm />
      <MainReview bg="--white" />
      <Location bg='--bg' />
    </StyledContact>
  );
}

const StyledContact = styled.main``;
